import { fetchMPTUsersStatistics, fetchMPTCardsStatistics } from "../../entities/mpt/stats";

export const scope = 'MPT_STATS';
export const REFRESH_STATS_MPT = 'REFRESH_STATS_MPT';

export function fetchStatsIfNeeded(payload) {
    return (dispatch, getState) => {
        const { userStats } = getState().app.mpt;

        if (!userStats.info.isFetching)
          dispatch(fetchMPTUsersStatistics(payload, scope));
    };
}

export function refreshStats(payload) {
    return (dispatch, getState) => {
        const { userStats } = getState().app.mpt;

        if (!userStats.info.isFetching)
            dispatch(fetchMPTUsersStatistics(payload || userStats.info.lastPayload, scope));
    };
}

export function fetchStatsCardsIfNeeded() {
    return (dispatch, getState) => {
        const { cardsStats } = getState().app.mpt;

        if (!cardsStats.info.isFetching)
            dispatch(fetchMPTCardsStatistics(scope));
    };
}



// WEBPACK FOOTER //
// ./src/actions/app/mpt/stats.js